<template>
    <div class="menus-bottom flex-1 flex">   
        <div class="menus-leftside">
            <WFScrollableArea ref="sidescroll">
                <WFPageMenu :container="container" :showIcon="true" @clicked="pageClick" :currentPage="page" :sortAZ="true"/>
            </WFScrollableArea>
        </div>
        <div class="menus-rightside">
            <WFScrollableArea class="filtered-scroll poi-list" ref="pagescroll">
                <div class="menus-rightside-content">
                    <div v-if="page">
                        <component v-if="page.type == 'component'" :is="itemType(page)" :page="page" @showRoute="showRoute" @viewOnMap="viewOnMap"></component> 
                        <WFPage v-if="page.type !== 'component'" :container="container" :slug="slug" />
                    </div>
                    <div v-if="!page" class="empty-group">
                        <div class="emtpy-arrow">
                            <WFIcon name="arrow_left"></WFIcon>
                            <WFTranslate k="emptry_group">Find your interest</WFTranslate>
                        </div>
                        <WFPage :container="container" slug="empty"/>
                    </div>
                </div>
            </WFScrollableArea>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import { WFScrollableArea, WFPageMenu, WFPage} from '@3dwayfinder/wayfinder-vue-components'
import PageAPP from './pages/PageAPP.vue';
import PageTRAINS from './pages/PageTRAINS.vue';
import PageMETRO from './pages/PageMETRO.vue';
import PageTRAMS from './pages/PageTRAMS.vue';
import PageBUSES from './pages/PageBUSES.vue';
import PageBIKES from './pages/PageBIKES.vue';
import PageACCESSIBILITY from './pages/PageACCESSIBILITY.vue';
import PageHSL from './pages/PageHSL.vue';
import PageTAXIS from './pages/PageTAXIS.vue';
import PageTICKETS from './pages/PageTICKETS.vue';
import PageBIKEHALL from './pages/PageBIKEHALL.vue';

export default {
    name: "pois",
    components: {
        WFScrollableArea,
        WFPageMenu,
        WFPage,
        PageAPP,
        PageACCESSIBILITY,
        PageTRAINS,
        PageMETRO,
        PageBUSES,
        PageTRAMS,
        PageBIKES,
        PageHSL,
        PageTAXIS,
        PageTICKETS,
        PageBIKEHALL
    },
    props: {
        container: {
			type: String,
			default: "default"
		},
        pageSlug: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            filteredPOIs: [],
            slug: null,
            page: null
        }
    },
    computed: {
		...mapState('wf', ['language', 'pages']),
    },
    watch: {
        container () {
            this.page = null;
        },
        pageSlug () {
            this.$nextTick(() => {
                console.log("pageSlug2", this.pageSlug, typeof this.pages[this.container])
                this.slug = this.pageSlug;
                if(this.pages[this.container]) {
                    this.page = Object.values(this.pages[this.container]).find((p) => {
                        return p.slug == this.slug;
                    })
                }
            })
        }
    },
    methods: {
        itemType (item) {
			if (item && item.slug) {
				return "Page"+item.slug.toUpperCase();
			}

			return "";
		},
        showRoute (type, groupName) {
            this.$emit('showRoute', type, groupName);
        },
        viewOnMap (type, groupName) {
            this.$emit('viewOnMap', type, groupName);
        },
        pageClick (page) {
            this.page = page;
            this.slug = page.slug;
            if(this.$refs.pagescroll) {
                this.$refs.pagescroll.reset();
            }
        },
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    
    .wf-page-menu {
        .wf-list-item {
            padding: 1.4rem 1.8rem !important;
            display: flex;
            align-items: center;

            label {
                line-height: 2.8rem;
                margin-top: 0.3rem;
            }

            .wf-icon {
                margin-right: 0.8rem; 
            }
            svg {
                width: 3.2rem;
                margin-bottom: -1.4rem;
            }

            &.wf-active {
                background-color: @primary-color;
                color: @primary-font-color;
            }
        }
    }
</style>